export default "__VITE_ASSET__D4Xi3K6S__"